import React, { useState, useEffect } from "react";
// import "./../assets/scss/partials/popup.scss";
import "./../assets/scss/custom/custom.scss";
import Minimodal from "./Custom/Modal/Minimodal";
import * as cryto from "./../commonFunc/Aes256";
import * as fnc from "./../commonFunc/CommonFunction";
import axios from "axios";

const PopupInfouser = ({ handleCloseButtonClick }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [AddMiniModal, setAddMiniModal] = useState(false); // minimodal
  const [Myinfo, setMyinfo] = useState([]);
  const [PasswordChangeshow, setPasswordChangeshow] = useState(false);
  const [CurrentPassword, setCurrentPassword] = useState("");
  const [NewPassword, setNewPassword] = useState("");
  const [ReenterNewPassword, setReenterNewPassword] = useState("");
  const [Checkpasswordresult, setCheckpasswordresult] = useState(false);
  const [MinimodalTxt, setMinimodalTxt] = useState("");

  useEffect(() => {
    setPasswordChangeshow(false);
    setCheckpasswordresult(false);
    setNewPassword("");
    setReenterNewPassword("");
    dataMyinfo();
    setAddMiniModal(false);
  }, []);

  const changePasswordShowHandler = () => {
    setPasswordChangeshow(true);
  };

  const dataMyinfo = () => {
    const Token = window.sessionStorage.getItem("Token");
    fnc.executeQueryGet({
      url: apiUrl + "/info",
      headers: {
        Authorization: Token,
        accept: "*/*",
        "Content-Type": "application/json",
      },
      success: (res) => {
        let accessToken = res.headers.authorization;
        setMyinfo(res.data);

        axios.defaults.headers.common["Authorization"] = accessToken;
        window.sessionStorage.setItem("Token", accessToken);
      },
      fail: (res) => {
        console.log(res);
        return;
      },
    });
  };

  // 현재 비밀번호 체크 함수
  const currentpasswordcheckHandler = () => {
    let body = {
      password: cryto.sha256(CurrentPassword),
    };

    axiosPost(body);
  };

  // axios post
  const axiosPost = (body) => {
    const Token = window.sessionStorage.getItem("Token"); //로그인 access토큰 가져오기
    fnc.executeQuery({
      url: apiUrl + "/password/check",
      data: body,
      headers: {
        Authorization: Token,
        accept: "*/*",
        "Content-Type": "application/json",
      },
      success: (res) => {
        setCheckpasswordresult(true);
        let accessToken = res.headers.authorization;

        axios.defaults.headers.common["Authorization"] = accessToken;
        window.sessionStorage.setItem("Token", accessToken);
      },
      fail: (res) => {
        console.log(res);
        return;
      },
    });
  };

  // 비밀번호 변경 함수
  const passwordchageHandler = () => {
    const body = {
      password: cryto.sha256(NewPassword),
    };
    const passwordPattern = /^(?=.*[0-9])(?=.*[!@#$%^&*()])(?=.{10,16}).*$/;
    const isValidPassword = passwordPattern.test(NewPassword);

    if (ReenterNewPassword !== NewPassword) {
      setMinimodalTxt("The password is different.");
      setAddMiniModal(true);
    } else if (ReenterNewPassword === NewPassword && !isValidPassword) {
      setMinimodalTxt(
        "The new password must be at least 10 characters and not more than 16 characters, including at least one digit/special character (!@#$%^&*())."
      );
      setAddMiniModal(true);
    } else if (
      Checkpasswordresult &&
      ReenterNewPassword === NewPassword &&
      isValidPassword
    ) {
      axiosPatch(body);
    }
  };

  const axiosPatch = (body) => {
    const Token = window.sessionStorage.getItem("Token"); //로그인 access토큰 가져오기
    fnc.executeQueryPatch({
      url: apiUrl + "/password/change",
      data: body,
      headers: {
        Authorization: Token, // 아까 signIn 할 때 받아온 token을 요청할 때 넘겨준다.
        accept: "*/*",
        "Content-Type": "application/json",
      },
      success: (res) => {
        let accessToken = res.headers.authorization; // res headers로 들어온 authorization 받아서 불러오기
        setMinimodalTxt("Your password has been changed.");
        setAddMiniModal(true);
        setPasswordChangeshow(false);

        axios.defaults.headers.common["Authorization"] = accessToken; //새로운 api의 access 토큰값으로 변경해주기
        window.sessionStorage.setItem("Token", accessToken);
      },
      fail: (res) => {
        console.log(res);
        return;
      },
    });
  };

  // Mini modal btn 함수
  const miniModalBtnHandler = () => {
    setAddMiniModal(false);
  };

  return (
    <div id="PopupInfouser">
      <Minimodal
        style={
          AddMiniModal === true ? { display: "block" } : { display: "none" }
        }
        modaltext={MinimodalTxt}
        modalbtn="Confirm"
        onClick={miniModalBtnHandler}
      />
      <div className="black_bg"></div>
      <div className="Popup_box modal_container myinfo">
        <div className="content">
          <div className="title">
            <h5>My Info.</h5>
          </div>
          <div class="myinfo_body">
            <table class="table">
              <tbody>
                <tr>
                  <th>Administrator Name</th>
                  <td>{Myinfo.name}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{Myinfo.email}</td>
                </tr>

                <tr>
                  <th>Password</th>
                  {PasswordChangeshow === true ? (
                    <td>
                      <div className="info-pw-wrap">
                        <div className="password_flex">
                          <input
                            className="new_password_form_control"
                            value={CurrentPassword}
                            onChange={(e) => {
                              setCurrentPassword(e.target.value);
                            }}
                            type="password"
                            placeholder="Enter Current Password"
                          ></input>
                          <button onClick={currentpasswordcheckHandler}>
                            Confirm
                          </button>
                        </div>
                        <input
                          className="new_password_form_control"
                          value={NewPassword}
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                          }}
                          type="password"
                          placeholder="Enter new Password"
                        ></input>
                        <div className="password_flex">
                          <input
                            className="new_password_form_control"
                            value={ReenterNewPassword}
                            onChange={(e) => {
                              setReenterNewPassword(e.target.value);
                            }}
                            type="password"
                            placeholder="Re-enter the new Password"
                          ></input>
                          <button
                            className={
                              Checkpasswordresult
                                ? "password_change_active"
                                : "password_change_active disabled"
                            }
                            onClick={passwordchageHandler}
                          >
                            Change
                          </button>
                        </div>
                      </div>
                    </td>
                  ) : (
                    <td>
                      <div class="info-pw">
                        <span>*********</span>
                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          onClick={changePasswordShowHandler}
                        >
                          Change Password
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
                <tr>
                  <th>Phone Number</th>
                  <td>+ {Myinfo.phoneNumber}</td>
                </tr>
                <tr>
                  <th>Permission</th>
                  <td class="phonenumber">{Myinfo.permission}</td>
                </tr>

                <tr>
                  <th>Group</th>
                  <td class="phonenumber">{Myinfo.group}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <button className="close_btn" onClick={handleCloseButtonClick}>
            Close
          </button>
          <div className="clear"></div>
        </div>
      </div>
    </div>
  );
};

export default PopupInfouser;
